import template from './passwordFormElement.html';
import controller from './passwordFormElement.controller';
import './passwordFormElement.scss';

let passwordFormElementComponent = {
  restrict: 'E',
  bindings: {
    label: '@',
    value: '=',
    validationError: '<'
  },
  template,
  controller
};

export default passwordFormElementComponent;
